import { render, staticRenderFns } from "./CurrentWeaponsRack.vue?vue&type=template&id=03a4c4c3&scoped=true&"
import script from "./CurrentWeaponsRack.vue?vue&type=script&lang=js&"
export * from "./CurrentWeaponsRack.vue?vue&type=script&lang=js&"
import style0 from "./CurrentWeaponsRack.vue?vue&type=style&index=0&id=03a4c4c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4c4c3",
  null
  
)

export default component.exports